<template>
  <div class="app-footer">
    <span>©{{ year }} {{ oemInfo.name }} 版权所有 </span>
    <a href="http://www.miitbeian.gov.cn/state/outPortal/loginPortal.action" target="_blank">{{ oemInfo.icp }}</a>
  </div>
</template>

<script>
export default {
  name: 'AppFooter',
  computed: {
    year () {
      const { formatDate } = this.$options.filters
      return formatDate(new Date(), 'YYYY', 'ms')
    },

    oemInfo () {
      return this.$store.state.share.oemInfo
    }
  }
}
</script>

<style lang="scss">
.app-footer {
  background-color: $background-color;
  color: #999;
  font-size: 12px;
  text-align: center;
}
</style>
